export enum CurrencyMap {
  CHF = 'CHF',
  GBP = '£',
  USD = '$',
  EUR = '€',
}
